import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAccounts } from '../services/accounts-data.service';
import { RequestStatus } from '../interface';
import { selectAccountsDataState } from '../selectors/accounts-data.selectors';
import { dataFetchingErrorHandler } from '../errors/dataFetchingErrorHandler';
const defaultResponse = {
  basicAccounts: [],
  pinnedAccountIds: [],
  isImpersonating: false
};
export const getAccountsDataThunk = createAsyncThunk('getAccountsData', async (portalId, {
  rejectWithValue
}) => {
  try {
    return await getAccounts(portalId);
  } catch (error) {
    const requestError = error;
    dataFetchingErrorHandler('Failed to fetch accounts')(requestError);
    return rejectWithValue(defaultResponse);
  }
}, {
  condition: (_, {
    getState
  }) => {
    const state = getState();
    const {
      status
    } = selectAccountsDataState(state);
    return status === RequestStatus.IDLE;
  }
});